module.exports = __webpack_public_path__ + "static/media/shares_management.ab52f982.mp4";